import React, { useState, useEffect } from 'react';
import { FadeLoader } from 'react-spinners';
import { styledTheme } from 'globalStyles/theme';
import Modal from 'react-modal';
import PropTypes from 'prop-types';

import {
  createSampleProject,
  fetchOrgSampleWeddingStatus,
  fetchOrgSampleWedding,
} from 'apollo/projects.query';
import ErrorModal from './ErrorModal';
import './styles.scss';

const CreateSampleProjectModal = ({ open, onClose }) => {
  const [sampleWedding, setSampleWedding] = useState({});
  const [sampleWeddingStatus, setSampleWeddingStatus] = useState('preparing');
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState(null);

  let timer;

  useEffect(() => {
    if (!open) {
      setSampleWedding({});
      setSampleWeddingStatus('preparing');
    } else {
      const CreateProject = async () => {
        try {
          const data = await createSampleProject();
          if (data.createSampleWedding.success) {
            timer = setInterval(getSampleWedding, 2000);
          }
        } catch (err) {
          onClose();
          setErrorModalMessage(
            "Sorry, but we couldn't create the sample wedding.  Please try again.",
          );
          setOpenErrorModal(true);
        }
      };
      CreateProject();
    }
  }, [open]);

  const getSampleWedding = async () => {
    try {
      const dataStatus = await fetchOrgSampleWeddingStatus();
      if (dataStatus.me.organization.sampleWeddingStatus !== 'preparing') {
        clearInterval(timer);
        setSampleWeddingStatus(dataStatus.me.organization.sampleWeddingStatus);
        const dataWedding = await fetchOrgSampleWedding();
        if (dataWedding.organizationSampleWedding.id) {
          setSampleWedding(dataWedding.organizationSampleWedding);
        } else {
          onClose();
          setErrorModalMessage(
            "Sorry, but we couldn't create the sample wedding.  Please try again.",
          );
          setOpenErrorModal(true);
        }
      }
    } catch (err) {
      clearInterval(timer);
      onClose();
      setErrorModalMessage(
        "Sorry, but we couldn't create the sample wedding.  Please try again.",
      );
      setOpenErrorModal(true);
    }
  };

  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={open}
        contentLabel="PodoModal"
        className="create_sample_project_modal__container"
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            padding: 0,
            backgroundColor: styledTheme.modalBackground,
          },
        }}
      >
        <header className="mb-4 create_sample_project_modal__title">
          Now, let’s get your feet wet.
        </header>
        <section className="create_sample_project_modal__content">
          <div>
            <section className="create_sample_project_modal__description">
              Dive into this sample project we’ve created for you, complete
              with your very first Aisle Planner clients (well, make-believe,
              anyway), Bethany and Will! In this project you’ll be able to see
              how our powerful planning and project management tools can help
              you, your team, and your clients stay organized and on the same
              page throughout the entire planning process.
            </section>
          </div>
          <button
            className="create_sample_project_modal__submit button"
            style={{
              visibility:
                sampleWeddingStatus !== 'preparing' ? 'visible' : 'hidden',
            }}
            onClick={() => {
              window.location.href = `/app/project/${sampleWedding.id}/dashboard`;
            }}
          >
            <div className="d-md-none">Jump on in!</div>
            <div className="d-none d-md-block">
              Jump on in! The water’s fine!
            </div>
          </button>
          {sampleWeddingStatus === 'preparing' && (
            <section className="create_sample_project_modal__app_loader">
              <FadeLoader
                color={styledTheme.lighterGray}
                loading={sampleWeddingStatus === 'preparing'}
                height={15}
                width={5}
                radius={5}
                margin={2}
              />
            </section>
          )}
        </section>
      </Modal>
      <ErrorModal
        open={openErrorModal}
        includePersistsMessage
        onClose={() => {
          setErrorModalMessage(null);
          setOpenErrorModal(false);
        }}
      >
        <div>{errorModalMessage}</div>
      </ErrorModal>
    </>
  );
};

CreateSampleProjectModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

CreateSampleProjectModal.defaultProps = {};

export default CreateSampleProjectModal;
